/* eslint react/prop-types: 0 */
import React from 'react';
import PropTypes from 'prop-types';
import { compose, setPropTypes, setDisplayName, branch, renderNothing } from 'recompose';
import classNames from 'classnames';
import rpCookie from 'rp-cookie';
import SubscriptionUpgrade from '../SubscriptionUpgrade';
import { withCollapsible } from '../../../../enhancers';
import { subscriptionSelect, subscriptionConfirm } from '../../../../actions/subscriptions';
import styles from './SubscriptionRenew.scss';

function SubscriptionRenew({ data, onExpand, expanded }) {
  const { id, priceId } = data;
  return (
    <div className={styles.root}>
      <button
        className={classNames('ui-btn', 'ui-btn_primary', styles.button)}
        onClick={onExpand}
      >
          Renew subscription
      </button>
      {
        expanded &&
        <SubscriptionUpgrade
          service={id}
          action={() => subscriptionConfirm({
              sessionId: rpCookie.sharedPermanent.get('rp_guid'),
              priceId,
              returnUrl: `//${global.location.host}/subscriptions/confirm/?action=renew`,
            })
          }
        />
      }
    </div>
  );
}

export default compose(
  setDisplayName('SubscriptionRenew'),
  setPropTypes({
    data: PropTypes.object.isRequired,
    expanded: PropTypes.bool.isRequired,
    onExpand: PropTypes.func.isRequired,
  }),
  withCollapsible(state => state.subscriptions, subscriptionSelect),
  branch(
    props => !props.expired,
    renderNothing,
  ),
)(SubscriptionRenew);
